import React, { useState } from "react"
import { DialogSaurus } from "../dialog-saurus/dialog-saurus"
import { useThemeQueries } from "theme/util-styles"
import { EnumDialogs, useDialogStore } from "services/store/dialog-store"
import { Box, Button, Grid } from "@material-ui/core"
import { MultiContratoModel } from "api/touchone/models/multi-contrato"
import { CardContrato } from "components/cards/card-contrato/card-contrato"
import { useNotificacoes } from "components/notificacoes"
import { CircularLoading } from "components/utils/circular-loading"

export const DialogSelecionarContrato = () => {
    const { isMobile } = useThemeQueries()
    const { openCloseDialog, dialogs } = useDialogStore()
    const aberto = dialogs[EnumDialogs.SelecionarContrato].aberto
    const { contratos, handleSelecionarContrato } = dialogs[EnumDialogs.SelecionarContrato].props
    const contratosList = contratos as MultiContratoModel[]
    const [contratoIdSelecionado, setContratoIdSelecionado] = useState<string>()
    const [carregando, setCarregando] = useState<boolean>(false)
    const { showErrorMessage } = useNotificacoes()

    const onClickConfirmarContrato = async () => {
        try {
            setCarregando(true)
            await handleSelecionarContrato(contratoIdSelecionado)
        } catch (err: any) {
            showErrorMessage(err.message)
        } finally {
            setCarregando(false)
        }
    }

    return (
        <DialogSaurus
            aberto={aberto}
            titulo={'Selecionar Contrato'}
            isButtonTitleClose
            tamanho="sm"
            fullScreen={isMobile}
            handleClickClose={() => openCloseDialog(EnumDialogs.SelecionarContrato, false)}
            bottomArea={(
                <Box p={2} gridGap={8} display="flex" flexDirection="column">
                    <Button fullWidth color="primary" size="large" variant="contained" onClick={onClickConfirmarContrato} disabled={!contratoIdSelecionado}>
                        Confirmar
                    </Button>
                </Box>
            )}>
            {carregando && <CircularLoading tipo="FULLSIZED" />}
            <Box p={2} width="100%" height="100%">
                <Grid container spacing={2}>
                    {contratosList.map((contrato) => (
                        <Grid item xs={12} key={contrato.contratoId}>
                            <CardContrato model={contrato} selecionado={contratoIdSelecionado === contrato.contratoId} onClick={setContratoIdSelecionado} />
                        </Grid>
                    ))}
                </Grid>
            </Box>
        </DialogSaurus>
    )
}